<p-dialog [(visible)]="display" [resizable]="false" [modal]="true" [style]="{'width': '305px'}"
  (onHide)="hide()" appendTo="body">
  <p-header>
    <span>{{title}}</span>
  </p-header>

  <form [formGroup]="settingsForm" style="overflow: hidden;">
      @if (mode == 'advanced') {
      <div class="mb-3 row">
          <div [ngClass]="{'has-error':!sheetsAcross.valid}">
              <span class="col-lg-6">Sheets Across:</span>
              <div class="col-lg-5">
                  <input type="number" class="form-control" [formControl]="sheetsAcross" />
              </div>
          </div>
      </div>
      }
      @if (mode == 'advanced') {
      <div class="mb-3 row">
          <div [ngClass]="{'has-error':!sheetsDown.valid}">
              <span class="col-lg-6">Sheets Down:</span>
              <div class="col-lg-5">
                  <input type="number" class="form-control" [formControl]="sheetsDown" />
              </div>
          </div>
      </div>
      }
      <div class="mb-3 row">
          <span class="col-lg-11">
              <input type="checkbox" [formControl]="includeDeviceLabels" />
              <span class="uv-checkbox-label">Include Device Labels</span>
          </span>
      </div>
      @if (mode == 'advanced') {
      <div class="mb-3 row">
          <span class="col-lg-11">
              <input type="checkbox" [formControl]="includeDeviceProperties" />
              <span class="uv-checkbox-label">Include Device Properties</span>
          </span>
      </div>
      }
      <div class="mb-3 row">
          <span class="col-lg-11">
              <input type="checkbox" [formControl]="includeLinkLabels" />
              <span class="uv-checkbox-label">Include Link Labels</span>
          </span>
      </div>
      @if (mode == 'advanced') {
      <div class="mb-3 row">
          <span class="col-lg-11">
              <input type="checkbox" [formControl]="includeLinkProperties" />
              <span class="uv-checkbox-label">Include Link Properties</span>
          </span>
      </div>
      }
      @if (mode == 'advanced') {
      <div class="mb-3 row">
          <span class="col-lg-11">
              <input type="checkbox" [formControl]="vsdxFormat" />
              <span class="uv-checkbox-label">VSDX Format</span>
          </span>
      </div>
      }
  </form>

  <p-footer>
    <button type="button" pButton icon="fa fa-check" (click)="export()" label="Export" [disabled]="!enableExport"></button>
    <button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
  </p-footer>

</p-dialog>